<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field
          id="vxmlName"
          v-model="node.name"
          label="Name"
          hide-details
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0">
        <div
          v-for="(cond, index) in property.conditions"
          :key="index"
          class="m-t-10"
        >
          <div
            v-if="cond.condition !== 'default'"
            class="d-flex align-start width100"
          >
            <h4
              class="m-t-10"
              :class="property.conditions.length > 2 ? 'text-condition' : ''"
            >
              {{
                property.conditions.length === 2 && index === 0
                  ? 'Then'
                  : topic[index]
              }}
            </h4>
            <v-textarea
              class="textarea-input overflow-x m-t-10 m-l-10"
              v-model="cond.condition"
              placeholder="${input.intent}=='contact-agent'"
              solo
              dense
              hide-details
              rows="3"
              @focus="conditionIndex(index)"
              @keyup.down="pressDown"
              @keyup.up="pressUp"
              @keydown.enter="onEnter"
              @keydown.tab="pressTab"
            ></v-textarea>
            <v-icon
              small
              class="m-t-10 m-l-10"
              :disabled="property.conditions.length <= min"
              @click="deleteCondition(index)"
            >
              fa-times-circle
            </v-icon>
          </div>
          <!-- === use for Intellisense  ===-->
          <intellisense-component
            v-if="currentIndex == index"
            :input="property.conditions[index].condition"
            :drawFlowItems="drawFlowItems"
            :currentIndex="currentIndex"
            class="intellisense-condition"
            :apiForIntellisense="apiForIntellisense"
            :start="start"
            :eventKey="eventKey"
            @clearSelected="clearSelected"
            @updateInputFromIntellisense="updateInputFromIntellisense"
          />
          <!-- === use for Intellisense ===-->
        </div>
      </v-col>
    </v-row>
    <div v-if="property.conditions.length < max" class="d-flex">
      <v-icon class="p-r-5" small @click="addCondition()">
        fa-plus-circle
      </v-icon>
      <div class="cursor-pointer" @click="addCondition()">
        Add condition
      </div>
    </div>

    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import NoteComponent from '../../../components/note'
// === use for Intellisense ===
import IntellisenseComponent from '../../../components/intellisense'
// === use for Intellisense ===
export default {
  props: {
    node: Object,
    // === use for Intellisense ===
    drawFlowItems: Object,
    apiForIntellisense: Object
    // === use for Intellisense ===
  },
  components: {
    NoteComponent,
    // === use for Intellisense ===
    IntellisenseComponent
    // === use for Intellisense ===
  },
  data() {
    return {
      property: {},
      topic: 'ABCDEFGHIJ',
      min: 2,
      max: 10,
      // === use for Intellisense ===
      //ใช้สำหรับนับว่าตอนนี้ เราคลิกที่ condition ไหนเพื่อเอาไปทำ intellisense
      currentIndex: 0,
      start: -1,
      isKeyTab: false,
      eventKey: ''
      // === use for Intellisense ===
    }
  },
  created() {
    this.property = this.node.property
  },
  methods: {
    addCondition() {
      if (this.property.conditions.length < this.max)
        this.property.conditions.splice(
          this.property.conditions.length - 1,
          0,
          { condition: '' }
        )
    },
    deleteCondition(index) {
      this.property.conditions.splice(index, 1)
    },
    // === use for Intellisense ===
    conditionIndex(index) {
      //ใช้สำหรับนับว่าตอนนี้ เราคลิกที่ condition ไหนเพื่อเอาไปทำ intellisense
      this.currentIndex = index
    },
    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter(e) {
      if (e.keyCode === 13 && this.start > -1) {
        //ใช้เช็คว่า ถ้าเรากดเลือก list อยู่จะไม่ขึ้น Newline
        this.eventKey = 'enter'
        this.start = -1
        e.preventDefault()
      }
      //ถ้าไม่ได้เลือก list จะ newline ทุกครั้งที่กด Enter
      this.eventKey = 'enter'
      this.start = -1
      //ถ้าไม่ได้เลือก list จะ newline ทุกครั้งที่กด Enter
    },
    clearSelected() {
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      this.property.conditions[this.currentIndex].condition = data
    }
    // === use for Intellisense ===
  }
}
</script>

<style scoped lang="scss">
.body-dialog {
  margin: 10px !important;
}
.text-condition {
  width: 20px;
  text-align: center;
}
// === use for Intellisense ===
.intellisense-condition {
  width: 80%;
  margin-left: 50px;
}
// === use for Intellisense ===
</style>
